export default __webpack_public_path__ + "static/media/Application_In_Phone.2f0f0576.png";